<script>
  import { createEventDispatcher, onMount } from 'svelte';

  let currentPage = 1;
  let lastPage = 100;
  let pageSize = 10;
  let maxNavButtons = 10;
  let allPages = [];
  let pages = [];
  const dispatch = createEventDispatcher();

  export let items;

  $: allPages = [...Array(Math.ceil(items.length / pageSize)).keys()];  
  $: if (Math.ceil(items.length / pageSize) <= maxNavButtons) {
      pages = allPages;
     } else if ((lastPage - currentPage) < maxNavButtons) {
       pages = allPages.slice(lastPage - maxNavButtons);
     } else {
      pages = allPages.slice(currentPage - 1, (currentPage - 1) + maxNavButtons); 
    }
  $: lastPage = allPages[allPages.length - 1];
  $: if(items) navigate(1);

  onMount(() => {
    navigate(1);
  });

  const navigate = (page) => {
    currentPage = page;
    dispatch('paginate', { items: items.slice(((currentPage - 1) * pageSize), ((currentPage - 1) * pageSize) + pageSize) });
  }
</script>

<ul class="pagination">
  <li class="page-item" class:disabled='{currentPage === 1}'>
    <a class="page-link" aria-label="First" on:click|preventDefault={() => navigate(1)}>
      <span aria-hidden="true">&laquo;&laquo;</span>
      <span class="sr-only">First</span>
    </a>
  <li class="page-item" class:disabled='{currentPage === 1}'>
    <a class="page-link" aria-label="Previous" on:click|preventDefault={() => navigate(currentPage - 1)}>
      <span aria-hidden="true">&laquo;</span>
      <span class="sr-only">Previous</span>
    </a>
  </li>
  {#each pages as page}
    <li class="page-item" class:active='{currentPage === page + 1}'>
      <a class="page-link" on:click|preventDefault={() => navigate(page + 1)}>{page + 1}</a>
    </li>
  {/each}
  <li class="page-item" class:disabled='{currentPage === lastPage + 1}'>
    <a class="page-link" aria-label="Next" on:click|preventDefault={() => navigate(currentPage + 1)}>
      <span aria-hidden="true">&raquo;</span>
      <span class="sr-only">Next</span>
    </a>
  </li>
  <li class="page-item" class:disabled='{currentPage === lastPage + 1}'>
    <a class="page-link" aria-label="Last" on:click|preventDefault={() => navigate(lastPage + 1)}>
      <span aria-hidden="true">&raquo;&raquo;</span>
      <span class="sr-only">Last</span>
    </a>
  </li>
</ul>